<template>
  <div>
    <component
      :is="componentName"
      has-filters
      short-info
      :current-task-id="currentTaskId"
    >
      <!--      <div slot="top" class="d-flex justify-content-between pb-4">-->
      <!--        <span></span>-->
      <!--        <router-link-->
      <!--          :to="{-->
      <!--            name: 'campaign-task-statistics',-->
      <!--            params: {-->
      <!--              id: $route.params.id,-->
      <!--              name: $route.params.name,-->
      <!--              taskId: currentTaskId-->
      <!--            }-->
      <!--          }"-->
      <!--        >-->
      <!--          {{ $t('fullList') }}-->
      <!--        </router-link>-->
      <!--      </div>-->
      <crawl-time
        v-if="componentName !== 'creative'"
        slot="crawl"
        :task-id="currentTaskId"
      />
    </component>
  </div>
</template>

<script>
import TaskCard from './TaskCard.vue';
import CrawlTime from './CrawlTime.vue';
import Twitter from './TaskStatistics/Twitter.vue';
import Facebook from './TaskStatistics/Facebook.vue';
import Bitcointalk from './TaskStatistics/BitcoinTalk.vue';
import Telegram from './TaskStatistics/Telegram.vue';
import Reddit from './TaskStatistics/Reddit.vue';
import Translations from './TaskStatistics/Translations.vue';
import Instagram from './TaskStatistics/Instagram.vue';
import Linkedin from './TaskStatistics/LinkedIn.vue';
import Steemit from './TaskStatistics/Steemit.vue';
import Youtube from './TaskStatistics/Youtube.vue';
import Medium from './TaskStatistics/Medium.vue';
import Vk from './TaskStatistics/Vkontakte.vue';
// import Airdrop from './TaskStatistics/Airdrop/index.vue';
import Creative from './TaskStatistics/Creative.vue';

export default {
  components: {
    Bitcointalk,
    Facebook,
    Instagram,
    Linkedin,
    Medium,
    Creative,
    Reddit,
    Steemit,
    Telegram,
    Twitter,
    Translations,
    Youtube,
    TaskCard,
    CrawlTime,
    Vk
  },

  props: {
    currentTaskId: {
      type: String,
      required: true
    }
  },

  computed: {
    componentName() {
      return this.$route.params.name;
    }
  }
};
</script>

<style lang="scss">
.task-progress {
  .task-card {
    &__header {
      height: 90px;
    }

    &__footer {
      line-height: 1rem;
      height: 74px;
    }
  }
}
</style>
